module.exports = __webpack_public_path__ + "static/10.1_the_hebrew_kingdoms-59b4f8e6555360a22b785bb5c63c3907.pdf";